var _templateObject;
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
import React from 'react';
import { Image } from '@fupa/fupa-uikit';
import styled, { css } from 'styled-components';
import { desktopContentWidth, elementsWidth2Columns, mobileContentWidth } from 'app/styles/media';
const ImageContainer = styled.div.withConfig({
  componentId: "sc-19jwb1u-0"
})(["height:56.25vw;width:100%;overflow:hidden;padding:0;max-width:", "px;max-height:", "px;", ""], props => props.theme.mobileContentWidth, props => props.theme.mobileContentWidth * 9 / 16, props => props.theme.desktopLayout(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n      max-width: ", "px;\n      max-height: ", "px;\n\n      ", "\n    "])), props.theme.elementsWidth2Columns, props.theme.elementsWidth2Columns * 9 / 16, props.heroLayout && css(["flex-flow:row nowrap;text-align:start;align-items:flex-end;justify-content:flex-start;width:100%;height:56.25vw;max-width:", "px;max-height:", "px;"], props.theme.desktopContentWidth, props.theme.desktopContentWidth * 9 / 16)));
const StreamTeaserImage = _ref => {
  let {
    entity,
    image,
    isHero
  } = _ref;
  // Set media queries as browser hint for sizes to fetch best image dimension due to different actualWidthFactor for mobile and desktop template
  // sizesHint: '(max-width: 640px) 100vw, (max-width: 970px) 640px, 475px'
  const sizesHint = "(max-width: ".concat(mobileContentWidth, "px) 100vw, (max-width: ").concat(desktopContentWidth, "px) ").concat(mobileContentWidth, "px, ").concat(isHero ? desktopContentWidth : elementsWidth2Columns, "px");

  // Provide actualWidthFactor only to set width and height of <img> to 100%, image dimension is detected because of sizesHint
  const actualWidthFactor = 1;
  return /*#__PURE__*/React.createElement(ImageContainer, {
    heroLayout: isHero,
    "data-sentry-element": "ImageContainer",
    "data-sentry-component": "StreamTeaserImage",
    "data-sentry-source-file": "streamTeaserImage.tsx"
  }, /*#__PURE__*/React.createElement(Image, {
    entity: entity,
    actualWidthFactor: actualWidthFactor,
    sizesHint: sizesHint,
    ratio: "16:9",
    src: image,
    eager: isHero,
    "data-sentry-element": "Image",
    "data-sentry-source-file": "streamTeaserImage.tsx"
  }));
};
export { StreamTeaserImage };